export const currency = {
	/**
	 * use this method to display any and all amount-values
	 * @param  {[number, string]} amount [200000]
	 * @return {[string]}                [2,00,000]
	 */
	format: function (amount, floatValue) {
		let formatted = '';
		!floatValue
			? (formatted = Math.floor(amount)
					?.toFixed(2)
					.toString()
					.replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'))
			: (formatted = amount
					.toLocaleString('en-IN', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})
					?.replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'));
		const firstSplit = formatted.split('.');
		if (firstSplit.length > 0 && parseInt(firstSplit[1]) > 0) {
		} else {
			formatted = formatted.split('.')[0];
		}
		return formatted;
	},
	/**
	 * use this method to parse amount-value back to number-only
	 * @param  {[number, string]} amount [200000]
	 * @return {[string]}                [2,00,000]
	 */
	parse: function (amount) {
		return parseInt(amount.split(',').join(''));
	},

	/**
	 * use this method before-submitting on any API-requests
	 * @param  {[string]} amount
	 * @return {[number]}
	 */
	beforeAPIRequest: function (amount) {
		return this.parse(amount);
	},
};
